import { RouteConfig } from 'vue-router';

import { TableName } from '@/enums/tableName.enum';
import { beforeCalendarRoute } from '@/routesUtils/calendar';
import { tryParseInt } from '@/utils/number';
import { getProfileId } from '@/utils/profile';
import ProfileCalendar from '@/views/profile/Calendar.vue';

export function profileCalendarRoute(name: string): RouteConfig {
  return {
    path: 'calendar/:view',
    name,
    component: ProfileCalendar,
    meta: {
      title: 'titles.profile.calendar'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      beforeCalendarRoute(
        to,
        to.params.profileId ? (tryParseInt(to.params.profileId) as number) : (getProfileId() as number),
        TableName.User,
        next
      );
    }
  };
}
